import { render } from "./marquee-sec.vue?vue&type=template&id=b6d2ac82&scoped=true"
import script from "./marquee-sec.vue?vue&type=script&lang=js"
export * from "./marquee-sec.vue?vue&type=script&lang=js"

import "./marquee-sec.vue?vue&type=style&index=0&id=b6d2ac82&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d2ac82"]])

export default __exports__